import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Grid } from 'react-md';
import { withRouter, Redirect } from 'react-router-dom';
import { fromJS } from 'immutable';

import { find, forEach, isEmpty } from 'lodash-es';

import * as productsActions from '../../Services/Products/actions';
import * as quotationsActions from '../../Services/Quotations/actions';

import WizardForm from './WizardForm';

import './NewQuotation.scss';

class NewQuotationSR extends Component {
  constructor(props) {
    super(props);

    this.state = {
      redirect: false,
      redirectTo: undefined,
    };
  }

  componentDidMount() {
    const { actions, dateFormat } = this.props;
    actions.fetchCommercialProductsV2({ date: new Date(), dateFormat });
  }

  componentWillUnmount() {
    const { actions } = this.props;
    actions.setRedirectStatus(false);
  }

  handleFetchProducts = date => {
    const { actions, dateFormat } = this.props;
    actions.fetchCommercialProductsV2({ date, dateFormat });
  };

  handleSelectProduct = product => {
    if (product !== 'undefined' && product.value !== 'undefined') {
      const { value, date } = product;
      const { actions, dateFormat, commercialproductsV2 } = this.props;
      const commercialproduct = find(commercialproductsV2, { value });
      actions.fetchNewQuotationSR({
        value: commercialproduct.product.id,
        date: date || new Date(),
        dateFormat,
        commercialproduct,
      });
    }
  };

  handleGetRoute = ({ route, query = '' }) => {
    this.setState({
      redirect: true,
      redirectTo: { pathname: route, query },
    });
  };

  render() {
    const {
      pageHead,
      pageTitle,
      defaultPageTitle,
      canonical,
      productWidget,
      commercialproductsV2,
      strings,
      isLoadingProducts,
      dateFormat,
      redirect,
      quotationID,
      location,
    } = this.props;

    const { redirect: redirectState, redirectTo: redirectToState } = this.state;

    const to = {
      pathname: `/quotations/${quotationID}`,
      state: { from: location },
    };

    if (redirect) {
      return <Redirect push to={to} preserveQueryString={false} />;
    }

    if (redirectState) {
      return <Redirect push to={redirectToState} />;
    }

    const helmet = (
      <Helmet>
        <meta charSet="utf-8" />
        <title>{strings[pageHead] || pageHead}</title>
        <meta name="description" content={strings[pageHead] || pageHead} />
        <link rel="canonical" href={canonical} />
      </Helmet>
    );
    const { product } = productWidget;

    const groupCommProd = {};
    forEach(commercialproductsV2, commProd => {
      const group = commProd?.custom_resources?.group;
      if (!groupCommProd[group.code]) {
        groupCommProd[group.code] = {
          id: group.code,
          name: group.name,
          iconName: group.icon,
          type: commProd.type,
          products: [commProd],
        };
      } else {
        groupCommProd[group.code].products.push(commProd);
      }
    });
    return (
      <div className="coog-app">
        {helmet}
        <h1 className="md-title md-cell md-cell--12">{strings[pageTitle] || defaultPageTitle}</h1>
        <Grid className="coog-grid new-quotation-grid">
          {!isLoadingProducts && !isEmpty(groupCommProd) && (
            <WizardForm
              commercialProducts={fromJS(groupCommProd)}
              product={product}
              strings={strings}
              dateFormat={dateFormat}
              handleFetchProducts={this.handleFetchProducts}
              handleSelectProduct={this.handleSelectProduct}
              handleGetRoute={this.handleGetRoute}
            />
          )}
        </Grid>
      </div>
    );
  }
}

NewQuotationSR.propTypes = {
  actions: PropTypes.shape({
    fetchCommercialProductsV2: PropTypes.func,
    fetchNewQuotationSR: PropTypes.func,
    setRedirectStatus: PropTypes.func,
  }).isRequired,
  pageHead: PropTypes.string,
  pageTitle: PropTypes.string,
  defaultPageTitle: PropTypes.string,
  canonical: PropTypes.string,
  strings: PropTypes.objectOf(PropTypes.string),
  productWidget: PropTypes.shape({
    product: PropTypes.shape({
      label: PropTypes.string,
      placeholder: PropTypes.string,
      title: PropTypes.string,
      subtitle: PropTypes.string,
    }),
    date: PropTypes.shape({
      label: PropTypes.string,
      placeholder: PropTypes.string,
    }),
    data: PropTypes.arrayOf(PropTypes.object),
  }),
  commercialproductsV2: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      value: PropTypes.number,
    })
  ),
  isLoadingProducts: PropTypes.bool.isRequired,
  dateFormat: PropTypes.string.isRequired,
  redirect: PropTypes.bool,
  quotationID: PropTypes.string,
  location: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
};

NewQuotationSR.defaultProps = {
  pageHead: 'title.quotation.page',
  pageTitle: 'title.quotation.create',
  defaultPageTitle: 'Sélectionnez un univers de besoin',
  canonical: 'http://www.coopengo.com/',
  productWidget: {
    product: {
      title: 'product.title',
      subtitle: 'product.subtitle',
      label: 'product.select.label',
      placeholder: 'product.select.placeholder',
    },
    date: {
      label: 'date',
    },
    data: [],
  },
  commercialproductsV2: [],
  strings: {},
  redirect: false,
  quotationID: undefined,
};

const mapStateToProps = state => {
  const commercialproductsV2 = state.toJS().products.commercialproductsV2.map(product => ({
    ...product,
    value: product.id,
    label: product.name,
    product: product.technical_product,
  }));
  const { redirect, quotationID } = state.toJS().quotations.current;

  return {
    commercialproductsV2,
    isLoadingProducts: state.toJS().products.loading.isLoadingProducts,
    strings: state.toJS().quotations.strings,
    dateFormat: state.toJS().system.dateFormat,
    redirect,
    quotationID,
  };
};

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({ ...productsActions, ...quotationsActions }, dispatch),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NewQuotationSR));
